export default "__VITE_ASSET__C3d$QjjX__"